import React from 'react'
import PropTypes from 'prop-types';

export const Button = (props) => (
  <button onClick={props.onClick} className={props.className}>
    {props.children}
  </button>);
  Button.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
  };

export const PrimaryButton = (props) => {
  return (
    <Button {...props} className={`link f5 br2 ph4 pv3 mb2 dib white bg-blue fw4 pointer b--none ${props.className}`} />
  )
}



export const SecondaryButton = (props) =>
  <Button {...props} className={`link f5 br2 ph4 pv3 mb2 dib bg-white blue fw4 pointer b--none ${props.className}`} />;



// WEBPACK FOOTER //
// ./src/components/Button.js